import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { Location, Product, ProductType } from './types';

export function useProducts() {
    return useQuery({
        queryKey: ['products'],
        queryFn: () => api.get<{ products: Product[] }>('/api/admin/products').then((r) => r.products ?? []),
    });
}

export function useProductTypes() {
    return useQuery({
        queryKey: ['products', 'types'],
        queryFn: () => api.get<{ types: ProductType[] }>('/api/admin/products/types').then((r) => r.types ?? []),
        staleTime: 10 * 60_000,
    });
}

export function useLocations() {
    return useQuery({
        queryKey: ['locations'],
        queryFn: () => api.get<{ locations: Location[] }>('/api/admin/locations').then((r) => r.locations ?? []),
    });
}
